/*  MUI  */
import { ArrowBack } from '@mui/icons-material';
import { Box, Button } from '@mui/material';

/*  Shared  */
import { FontSizes } from 'application/Shared/Constants';
import { Route } from 'application/Shared/Helpers';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router';

export const PartnerBackButton = ({ linkTo, textOverride }) => {
    const { partnerId } = useParams();
    const basePartnerRoute = Route.buildBasePartnerRoute({
        partnerId
    });

    const partnerLink = `${basePartnerRoute}${linkTo}`;

    return (
        <BackButton
            data-trackid="partner_backButton"
            linkTo={partnerLink}
            textOverride={textOverride}
        />
    );
};

export const AdminBackButton = ({ linkTo }) => {
    const { clientId, partnerId } = useParams();
    const baseAdminRoute = Route.buildBaseAdminRoute({
        clientId,
        partnerId
    });

    const adminLink = `${baseAdminRoute}${linkTo}`;

    return <BackButton data-trackid="admin_backButton" linkTo={adminLink} />;
};

export const BackButton = ({
    'data-trackid': dataTrackid = 'backButton',
    linkTo,
    textOverride
}) => {
    const { t } = useTranslation();
    return (
        <Box mb="16px" data-testid="backButton">
            <Link to={linkTo} data-trackid={`${dataTrackid}_routeTo`}>
                <Button
                    data-trackid={dataTrackid}
                    color="primary"
                    variant="text"
                >
                    <ArrowBack
                        style={{
                            fontSize: FontSizes[1],
                            marginRight: '4px'
                        }}
                    />
                    {t(textOverride) || t('Common.back')}
                </Button>
            </Link>
        </Box>
    );
};
